import { ElementType, Suspense } from 'react';
import Splash from '../splash';

export const Loadable = (Component: ElementType) => (props: any) =>
  (
    <Suspense fallback={<Splash />}>
      <Component {...props} />
    </Suspense>
  );
